import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from '@/modules/timepicker';

export default Vue.component('service-countdown-set', {
  template: require('./template.html'),
  computed: {
    setCount() {
      const setCount = this.droplet.clock.sets.length;
      let disableClass = false;
      if (setCount < 2) {
        disableClass = true;
      }
      return disableClass;
    },
  },
  data() {
    return {
      dateFormat: 'D dsu MMM yyyy',
      timeFormat: 'hh:mm A',
      displayTime: this.set.endTime,
      displayDate: this.set.endDate.date,
      highlightDate: {
        dates: [
          new Date(),
        ],
      },
      selectedBufferDur: this.set.bufferDur,
      durations: [
        { duration: 'Seconds', value: 'seconds' },
        { duration: 'Minutes', value: 'minutes' },
        { duration: 'Hours', value: 'hours' },
      ],
    };
  },
  components: {
    Datepicker,
    VueTimepicker,
  },
  name: 'service-countdown-set',
  props: ['index', 'droplet', 'set'],
  methods: {
    async setDate(val) {
      const payload = {};
      payload.drp = this.droplet;
      payload.index = this.index;
      payload.endDate = val.toISOString();
      await this.promise(
        this.$store.dispatch('setCountdownEndDate', payload),
        'setting end date',
      );
      this.setFinalEnd();
    },
    async setTime(val) {
      const payload = {};
      payload.drp = this.droplet;
      payload.index = this.index;
      payload.endTime = val.data;
      await this.promise(
        this.$store.dispatch('setCountdownEndTime', payload),
        'setting end time',
      );
      this.setFinalEnd();
    },
    concatEnd(val) {
      return `${val.H}:${val.mm}:${val.ss} ${val.A}`;
    },
    setFinalEnd() {
      // this combines the selected time and date for the jquery plugin
      const set = this.set;
      const date = new Date(set.endDate.date);
      const min = parseInt(set.endTime.mm, 10);
      const hr = parseInt(set.endTime.HH, 10);
      date.setMinutes(min);
      date.setHours(hr);
      date.setSeconds(0);
      const payload = {};
      payload.drp = this.droplet;
      payload.index = this.index;
      payload.end = date.toISOString();
      this.$store.dispatch('setCountdownFinalEnd', payload);
    },
    setBufferTime(e) {
      const payload = {};
      payload.drp = this.droplet;
      const newBufferTime = parseInt(e.currentTarget.value, 10);
      let time = 0;
      if (newBufferTime !== '' && newBufferTime >= 0) {
        time = newBufferTime;
      }
      payload.index = this.index;
      payload.bufferTime = time;
      this.promise(
        this.$store.dispatch('setCountdownBufferTime', payload),
        'setting buffer time',
      );
    },
    setBufferDur(v) {
      const payload = {};
      payload.drp = this.droplet;
      payload.index = this.index;
      payload.bufferDur = v;
      this.promise(
        this.$store.dispatch('setCountdownBufferDur', payload),
        'setting buffer duration',
      );
    },
    setRecur(e) {
      const payload = {};
      payload.drp = this.droplet;
      const box = e.currentTarget;
      let recur = false;
      if (box.checked) {
        recur = 'every week';
      }
      payload.index = this.index;
      payload.recurring = recur;
      this.promise(
        this.$store.dispatch('setCountdownRecur', payload),
        'setting recur',
      );
    },
    setEndedMsg(e) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.index = this.index;
      payload.endMessage = val.trim() === '' ? false : val;
      this.promise(
        this.$store.dispatch('setCountdownEndMsg', payload),
        'setting end message',
      );
    },
    removeSet(i) {
      if (this.droplet.clock.sets.length > 1) {
        const payload = {};
        payload.drp = this.droplet;
        payload.index = i;
        this.promise(
          this.$store.dispatch('removeCountdownSet', payload),
          'removing set',
        );
        let newIndex = i - 1;
        if (newIndex < 0) {
          newIndex = 0;
        }
        this.$vnode.context.changeSelectedSet(newIndex);
      }
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in countdown: ${error}`));
        }
      });
      promise.then(() => {
        this.$emit('emit-sets-string');
        // so we won't see a flicker in the jquery plugin
        setTimeout(() => {
          this.$parent.$parent.$vnode.context.unBindPlugin();
        }, 100);
      });
    },
    drzRevertData() {
      this.displayTime = this.set.endTime;
      this.displayDate = this.set.endDate.date;
      this.selectedBufferDur = this.set.bufferDur;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/service-countdown/components/service-set/index.js